import format from '../plugins/baseFormat';
import dayjs from 'dayjs';
import baseFormat from '../plugins/baseFormat';
import { STATUS, STATUS_COLORS, POSSIBLE_STATUS_CHANGES, } from '@/modules/drivers/constants';

export default class Driver {
  constructor (initialData = {},) {
    const {
      _id,
      full_name,
      birth_date,
      created_at,
      cpf,
      rg,
      mei,
      email,
      phone,
      address,
      birth_address,
      bank_account,
      delivery_mode,
      vehicles,
      cnh,
      compartment,
      status,
      average_rating,
      franchises,
      idwall_report,
      indication,
      occurrences,
      orders,
      field_problems,
      operating_hours,
      shipment_count,
      logistic_operator,
      last_order,
      attachments,
      dispatch_type,
      dispatch_history,
      recent_occurrences,
      disponible,
    } = initialData;

    this._id = _id,
    this.checked = false,
    this.full_name = full_name,
    this.birth_date = birth_date,
    this.created_at = created_at,
    this.cpf = cpf,
    this.rg = rg,
    this.mei = mei,
    this.email = email,
    this.phone = phone,
    this.franchises = franchises || [],
    this.field_problems = field_problems || [],
    this.address = address,
    this.birth_address = birth_address,
    this.bank_account = bank_account,
    this.delivery_mode = delivery_mode,
    this.dispatch_type = dispatch_type,
    this.recent_occurrences = recent_occurrences || 0,
    this.cnh = cnh,
    this.status = status,
    this.average_rating = average_rating,
    this.idwall_report = idwall_report,
    this.indication = indication,
    this.orders = orders,
    this.shipment_count = shipment_count,
    this.last_order = last_order,
    this.disponible = disponible,
    this.dispatch_history = dispatch_history && dispatch_history.length ?
      dispatch_history.map((item,) => ({
        formatted_dispatch_type: {
          'POOL': 'Compartilhado',
          'DEDICATED': 'Dedicado',
        }[item.dispatch_type],
        formatted_update_date: baseFormat.dateFromNow(item.created_at,),
      }),) : [],
    this.logisticOperator_id =
      logistic_operator && logistic_operator.value
        ? logistic_operator.value
        : undefined,
    this.vehicles = (vehicles || []).map((vehicle,) => {
      return {
        ...vehicle,
        attachment: !vehicle.attachment
          ? {}
          : {
            ...vehicle.attachment,
            name: `CRLV_${vehicle?.renavam || cpf}_${vehicle.plate}`,
          },
        formatted_type: this._formatVehicleType(vehicle.type,),
        formatted_status:
            vehicle.status === 'APPROVED'
              ? 'Aprovado'
              : vehicle.status === 'DISAPPROVED'
                ? 'Reprovado'
                : 'Pendente',
      };
    },),
    this.compartment = {
      ...compartment,
      formatted_type: (compartment || {}).type == 'TRUNK' ? 'Baú' : 'Bag',
    },
    this.occurrences = (occurrences || []).map((occurrence,) => {
      return {
        ...occurrence,
        formatted_status:
            occurrence.status === 'VERIFIED'
              ? 'Verificado'
              : 'Pendente',
        formatted_occurrence_date: dayjs(occurrence.created_at || new Date(),).
          format('DD/MM/YY',),
      };
    },).reverse().slice(0, 3,),
    this.attachments = (attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
            attachment.status === 'APPROVED'
              ? 'Aprovado'
              : attachment.status === 'DISAPPROVED'
                ? 'Reprovado'
                : 'Pendente',
        name: `${attachment.
          attachment_type.
          split('_',)[0]}_${cpf}.${attachment.key.split('.',)[1]}`,
      };
    },),
    this.operating_hours = operating_hours || {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: [],
    };
  }

  _formatVehicleType (type,) {
    return {
      BIKE: 'Bicicleta',
      MOTORCYCLE: 'Moto',
      ON_FOOT: 'A pé',
      CAR: 'Carro',
    }[type] || 'Desconhecido';
  }

  _formatDeliveryMode (mode,) {
    return {
      MOTORIZED: 'Motorizado',
      NON_MOTORIZED: 'Não motorizado',
    }[mode] || 'Desconhecido';
  }

  set driver (driver,) {
    this._id = driver._id,
    this.checked = false,
    this.full_name = driver.full_name,
    this.birth_date = driver.birth_date,
    this.created_at = driver.created_at,
    this.cpf = driver.cpf,
    this.rg = driver.rg,
    this.mei = driver.mei,
    this.email = driver.email,
    this.phone = driver.phone,
    this.franchises = driver.franchises || [],
    this.field_problems = driver.field_problems || [],
    this.address = driver.address,
    this.birth_address = driver.birth_address,
    this.bank_account = driver.bank_account,
    this.delivery_mode = driver.delivery_mode,
    this.dispatch_type = driver.dispatch_type,
    this.recent_occurrences = driver.recent_occurrences || 0,
    this.cnh = driver.cnh,
    this.status = driver.status,
    this.average_rating = driver.average_rating,
    this.idwall_report = driver.idwall_report,
    this.indication = driver.indication,
    this.orders = driver.orders,
    this.shipment_count = driver.shipment_count,
    this.last_order = driver.last_order,
    this.disponible = driver.disponible,
    this.dispatch_history = driver.dispatch_history && driver.dispatch_history.length ?
      driver.dispatch_history.map((item,) => ({
        formatted_dispatch_type: {
          'POOL': 'Compartilhado',
          'DEDICATED': 'Dedicado',
        }[item.dispatch_type],
        formatted_update_date: baseFormat.dateFromNow(item.created_at,),
      }),) : [],
    this.logisticOperator_id =
      driver.logistic_operator && driver.logistic_operator.value
        ? driver.logistic_operator.value
        : undefined,
    this.vehicles = (driver.vehicles || []).map((vehicle,) => {
      return {
        ...vehicle,
        attachment: !vehicle.attachment
          ? {}
          : {
            ...vehicle.attachment,
            name: `CRLV_${vehicle.renavam || driver.cpf}_${vehicle.plate}`,
          },
        formatted_type: this._formatVehicleType(vehicle.type,),
        formatted_status:
            vehicle.status === 'APPROVED'
              ? 'Aprovado'
              : vehicle.status === 'DISAPPROVED'
                ? 'Reprovado'
                : 'Pendente',
      };
    },),
    this.compartment = {
      ...driver.compartment,
      formatted_type: (driver.compartment || {}).type == 'TRUNK' ? 'Baú' : 'Bag',
    },
    this.occurrences = (driver.occurrences || []).map((occurrence,) => {
      return {
        ...occurrence,
        formatted_status:
            occurrence.status === 'VERIFIED'
              ? 'Verificado'
              : 'Pendente',
        formatted_occurrence_date: dayjs(occurrence.created_at || new Date(),).
          format('DD/MM/YY',),
      };
    },).reverse().slice(0, 3,),
    this.attachments = (driver.attachments || []).map((attachment,) => {
      return {
        ...attachment,
        formatted_status:
            attachment.status === 'APPROVED'
              ? 'Aprovado'
              : attachment.status === 'DISAPPROVED'
                ? 'Reprovado'
                : 'Pendente',
        name: `${attachment.
          attachment_type.
          split('_',)[0]}_${driver.cpf}.${attachment.key.split('.',)[1]}`,
      };
    },),
    this.operating_hours = driver.operating_hours || {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: [],
    };
  }

  set orders (orders,) {
    this._orders = orders && orders.length ? orders.map((item,) => ({
      code: item.code || item.tracking_info.task_id,
      formatted_date: format.dateFromNow(item.created_at,),
      formatted_value: (() => {
        if (!item.delivery_form.price) { return '-'; }
        return format.money(item.delivery_form.price,);
      })(),
      formatted_status: (() => ({
        ASSIGNED: 'Atribuído',
        CREATED: 'Não atribuído',
        ON_THE_WAY: 'A caminho',
        CHECKED_IN: 'Chegou ao destino',
        DONE: 'Concluído',
        NOT_USED: 'Status não usado',
        ACCEPTED: 'Aceito',
        CANCELED: 'Cancelado',
        REJECTED: 'Rejeitado',
        UNACKNOWLEDGED: 'Status desconhecido',
      }[item.tracking_info.tracking_status]))(),
    }),)
      : [];
  }

  get orders () {
    return this._orders;
  }

  get formatted_dispatch_type () {
    if (!this.dispatch_type) { return 'Auto-Dispatch não definido'; }
    return {
      'POOL': 'Compartilhado',
      'DEDICATED': 'Dedicado',
    }[this.dispatch_type];
  }

  get formatted_shipment_count () {
    if (!this.shipment_count) { return 0; }
    return String(this.shipment_count,).padStart(2, '0',);
  }

  get formatted_last_order () {
    if (this.last_order) { return format.dateFromNow(this.last_order,); }
    return '-';
  }

  get formatted_rating () {
    if (!this.average_rating) { return '-'; }

    return (Math.floor(this.average_rating * 10,) / 10);
  }

  get formatted_status () {
    return STATUS[this.status] || 'Desconhecido';
  }

  get status_color () {
    return STATUS_COLORS[this.status] || 'gray';
  }

  get possible_edit_status () {
    return POSSIBLE_STATUS_CHANGES[this.status] || null;
  }

  get formatted_possible_status () {
    return STATUS[this.possible_edit_status] || null;
  }

  get formatted_cpf () {
    return format.cpf(this.cpf,);
  }

  get formatted_birth_date () {
    return format.utcDate(this.birth_date,).format('DD/MM/YYYY',);
  }

  get formatted_phone () {
    return format.phone(this.phone,);
  }

  // Data de cadastro do Entegador - Formatada
  get formatted_created_at () {
    return format.utcDate(this.created_at,).format('DD/MM/YYYY',);
  }

  get formatted_recent_occurrences () {
    const overOne = this.recent_occurrences > 1;
    if (this.recent_occurrences) {
      return `${this.
        recent_occurrences} nova${overOne ? 's' : ''} atividade${overOne ? 's' : ''}`;
    }
    return 'Sem atividade';
  }

  get formatted_city_state () {
    return `${this.address.city} - ${this.address.state}`;
  }

  get toPost () {
    let response = {
      address: this.address,
      attachments: this.attachments.map((attachment,) => {
        return {
          attachment_type: attachment.attachment_type,
          bucket: attachment.bucket,
          key: attachment.key,
          region: attachment.region,
        };
      },),
      bank_account: this.bank_account,
      birth_address: this.birth_address,
      cpf: baseFormat.cleanCpf(this.cpf,),
      delivery_mode: this.delivery_mode,
      email: this.email,
      franchises: this.franchises,
      full_name: this.full_name,
      indication: this.indication,
      phone: baseFormat.cleanPhone(this.phone,),
      vehicles: this?.vehicles?.length ? this.vehicles.map((vehicle,) => ({
        plate: vehicle.plate,
        type: vehicle.type,
      }),) : undefined,
    };

    return response;
  }
}
